module.exports = __webpack_public_path__ + "static/media/Add.a91d5f0c.svg";